import React from 'react';
import { SignUpWrapper } from './SignUpWrapper';
import { RegisterGymForm } from '../../../Components/forms/AuthenticationForms/RegisterGym';
import RegisterGymFormContainer from '../../FormContainers/Authentication/RegisterGymForm';

export const RegisterGym = () => (
    <SignUpWrapper
        title={'Sign up your gym'}
        subtitle={'Sign up today for a free 3 month trial, normally £49.00 a month'}
    >
        <RegisterGymFormContainer renderForm={props => <RegisterGymForm {...props} />} />
    </SignUpWrapper>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/SignUp/RegisterGym.js